function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo, useCallback } from "react";
import AutoSelect from "../AutoSelect";
import Box from "../Box";
import Chip from "../Chip";
import { styled } from '../styles';
import { createEmptyAppliedFilter } from ".";
const AutoSelectStyled = styled(AutoSelect)(() => ({
  display: "flex",
  flex: 1
}));
const ListFilterMultiSelect = _ref => {
  let {
    searchFilter,
    appliedSearchFilter,
    onChangeAppliedFilter
  } = _ref;
  const appliedFilterValues = useMemo(() => {
    return (appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues.length) > 0 ? appliedSearchFilter.filterValues : [];
  }, [appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues //needed to shallow compare changes 
  ]);
  const appliedFilterListValuesOptions = useMemo(() => {
    if (appliedFilterValues.length > 0) {
      return appliedFilterValues.map(value => ({
        value: value.value,
        label: value.label
      }));
    } else {
      return [];
    }
  }, [appliedFilterValues]);
  const handleChangeValue = useCallback((e, valueOptions) => {
    if (valueOptions != null && valueOptions.length > 0) {
      const filterValues = valueOptions.map(valueOption => {
        return {
          value: valueOption.value,
          label: valueOption.label,
          context: null
        };
      });
      const newAppliedSearchFilter = appliedSearchFilter ? appliedSearchFilter : createEmptyAppliedFilter(searchFilter);
      newAppliedSearchFilter.filterValues = filterValues;
      const plusLabel = filterValues.length > 1 ? " + ".concat(filterValues.length - 1) : "";
      newAppliedSearchFilter.displayLabel = "".concat(searchFilter.label, ": ").concat(filterValues[0].label).concat(plusLabel);
      onChangeAppliedFilter(searchFilter, newAppliedSearchFilter);
    } else {
      onChangeAppliedFilter(searchFilter, null);
    }
  }, [searchFilter, appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues,
  //needed to shallow compare changes 
  onChangeAppliedFilter, createEmptyAppliedFilter]);
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      flex: 1,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement(AutoSelectStyled, {
    onChange: handleChangeValue,
    multiple: true
    // label={searchFilter.label}
    ,
    ariaLabel: searchFilter.label,
    value: appliedFilterListValuesOptions,
    getOptionSelected: (option, value) => option.value === value.value,
    options: searchFilter.options,
    isOptionEqualToValue: (option, value) => option.value === value.value,
    InputProps: {
      sx: {
        width: "100%"
      }
    },
    renderTags: (valueOptions, getTagProps) => valueOptions.map((option, index) => /*#__PURE__*/React.createElement(Box, {
      sx: {
        margin: 0.5
      }
    }, /*#__PURE__*/React.createElement(Chip, _extends({
      variant: "outlined",
      label: option.label
    }, getTagProps({
      index
    })))))
  }));
};
export default ListFilterMultiSelect;